module.exports = __webpack_public_path__ + "img/mp3.6857d6ae.png";